import { useRive, useStateMachineInput } from '@rive-app/react-canvas';
import { Input } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { type ChangeEvent, memo, useCallback, useContext, useEffect, useState } from 'react';
import { NestleFormWrapperContext } from 'reactApp/sections/Nestle/FormWrapper/FormWrapper.context';
import { animations, backgroundImages } from 'reactApp/sections/Nestle/PetsCard/SecondNickname/SecondNickname.data';

import commonStyles from '../PetsCard.css';
import styles from './SecondNickname.css';

const RIVE_STATE_MACHINE_NAME = 'Heart State Machine';
const RIVE_TRIGGER_NAME = 'Trigger 1';

export const SecondNickname = memo(() => {
    const [animationSrc, setAnimationSrc] = useState<string>('');
    const { formData, formErrors, setFormData, setFormErrors } = useContext(NestleFormWrapperContext);
    const { cardColor } = formData;

    const { rive, RiveComponent } = useRive({
        src: animationSrc,
        stateMachines: RIVE_STATE_MACHINE_NAME,
        autoplay: true,
    });

    const backgroundImage = backgroundImages[cardColor];

    const triggerAnimation = useStateMachineInput(rive, RIVE_STATE_MACHINE_NAME, RIVE_TRIGGER_NAME);

    const handleChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            triggerAnimation?.fire();
            setFormData((prev) => ({ ...prev, nickname2: event.target.value }));
            if (formErrors.nickname2) {
                setFormErrors((prev) => ({ ...prev, nickname2: false }));
            }
        },
        [triggerAnimation, setFormData, formErrors.nickname2, setFormErrors]
    );

    useEffect(() => {
        setAnimationSrc(animations[cardColor]);
    }, [cardColor, setAnimationSrc]);

    return (
        <div className={classNames(commonStyles.field, commonStyles.nickname2)}>
            <span className={commonStyles.label}>для друзей</span>
            <Input
                placeholder="добавьте ласковую кличку"
                type="text"
                className={classNames(commonStyles.input, {
                    [commonStyles.inputError]: formErrors.nickname2,
                })}
                onChange={handleChange}
            />
            <div
                className={classNames(styles.animation, {
                    [styles[`animation_${cardColor}`]]: cardColor,
                })}
            >
                <img src={backgroundImage} alt="nickname-background" className={styles.image} />
                <div className={styles.animationDesktop}>
                    <RiveComponent key={animationSrc} />
                </div>
            </div>
        </div>
    );
});

SecondNickname.displayName = 'SecondNickname';
